import React from 'react';
interface AvatarProps {
  text?: string;
  color?: string;
  indicator?: 'online' | 'offline' | 'away';
  size?: 'sm' | 'md' | 'lg';
}
export function Avatar({
  text,
  color = '#ff9500',
  indicator,
  size = 'md'
}: AvatarProps) {
  const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-10 h-10 text-base'
  };
  return <div className="relative inline-block" data-id="element-3">
      <div className={`${sizeClasses[size]} rounded-full flex items-center justify-center font-semibold text-black`} style={{
      backgroundColor: color
    }} data-id="element-4">
        {text}
      </div>
      {indicator && <div className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-[#1a1a1a] ${indicator === 'online' ? 'bg-green-500' : indicator === 'away' ? 'bg-yellow-500' : 'bg-gray-500'}`} data-id="element-5" />}
    </div>;
}